<off-canvas-menu-body [isVisible]="client.isPrerender || client.isBot || isVisible()"
                      offClickFilter=".off-canvas-close,.off-canvas-menu-open"
                      (offClick)="close()"
                      (hide)="close()" />